/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Observable } from 'rxjs';

export abstract class DisablableCheckbox {
  readonly disabled$: Observable<boolean>;
}
